module.exports = {
  NavIconDashboard: require('./Dashboard'),
  NavIconTrx: require('./Trx'),
  NavIconCustomers: require('./Customers'),
  NavIconRetailers: require('./Retailers'),
  NavIconGlobals: require('./Globals'),
  NavIconPartners: require('./Partners'),
  NavIconAnalytics: require('./Analytics'),
  NavIconWithdraws: require('./Withdraws'),
  NavIconStatements: require('./Statements'),
  NavIconSettings: require('./Settings')
}
